import {formatFloat} from '@hconnect/uikit/src/common/utils/unitFormatting'

export const getPercentageInDecimal = (value: number, total: number, decimalPlaces = 1) => {
  const fraction = value / total
  return `${formatFloat(fraction * 100, decimalPlaces)}%`
}
